import { render } from "./SortTableFirstRowComponent.vue?vue&type=template&id=c678a0ea&scoped=true"
import script from "./SortTableFirstRowComponent.vue?vue&type=script&lang=js"
export * from "./SortTableFirstRowComponent.vue?vue&type=script&lang=js"

import "./SortTableFirstRowComponent.vue?vue&type=style&index=0&id=c678a0ea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c678a0ea"]])

export default __exports__